import { useMutation } from '@hooks/reactQuery';

import { createAlarmNoVesRules } from '@api/alarmManagement';

import { IAlarmCreateNoVeRuleDTO } from '@interfaces/alarms/dto/alarmsDTO';

import { ALARM_CREATE_NO_VES_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsCreateNoVesRulesReturn {
	addAlarmNoVesRules: (data: IAlarmCreateNoVeRuleDTO[]) => void;
	isLoadingAddAlarmNoVesRules: boolean;
}

export const useMutateAlarmsCreateNoVesRules = (): IUseMutateAlarmsCreateNoVesRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<IAlarmCreateNoVeRuleDTO[]>({
		mutationKey: [ALARM_CREATE_NO_VES_RULE_ORAN],
		mutationFn: createAlarmNoVesRules,
	});

	return {
		addAlarmNoVesRules: mutateAsync,
		isLoadingAddAlarmNoVesRules: isLoading,
	};
};
